export class SolicitacaoAcesso {
  constructor({
    id = null,
    nome = null,
    cpf = null,
    email = null,
    telefone = null,
    escolaridade = null,
    lotacao = null,
    funcao = null,
    municipio = null,
    situacao = null,
    perfil = null,
    justificativa = null,
    possuiLotacaoDois = null,
    possuiNomeSocial = null,
    municipioDois = null,
    lotacaoDois = null,
    nomeSocial = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.cpf = cpf;
    this.email = email;
    this.telefone = telefone;
    this.escolaridade = escolaridade;
    this.lotacao = lotacao;
    this.funcao = funcao;
    this.municipio = municipio;
    this.situacao = situacao;
    this.perfil = perfil;
    this.justificativa = justificativa;
    this.possuiLotacaoDois = possuiLotacaoDois;
    this.possuiNomeSocial = possuiNomeSocial;
    this.municipioDois = municipioDois;
    this.lotacaoDois = lotacaoDois;
    this.nomeSocial = nomeSocial;
  }
  static Build() {
    return new SolicitacaoAcesso({
      id: null,
      situacao: null,
      perfil: null,
      justificativa: null,
    });
  }
}
